import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { QuestionPapers } from "../entities/question-papers";
import { ClassRequestModel, QNPIdReq, QPaperMergeGerReqModel, qPRequestModel } from "@boi/shared-models";
import { QuestionPaperModal } from "../../model-paper/entities/question-paper-modal";
import { SectionQuestionMappingEntity } from "../entities/section-question-mapping.entity";
import { SectionWiseModel } from "../../model-paper/entities/section-wise-model.entity";
import { ClassEntity } from "../../entities/class";
import { Subject } from "../../entities/subject";
import { LanguageEntity } from "../../entities/language";

@Injectable()
export class QuestionPapersRepo extends Repository<QuestionPapers> {
    constructor(private dataSource: DataSource) {
        super(QuestionPapers, dataSource.createEntityManager());
    }

    async getQuestionPaperDataById(req: QNPIdReq) {
        const classData = await this.createQueryBuilder('qp')
            .select(`qp.*,class.class as class_name,subject.subject as subject_name,language.language as language_name,qpm.*,sQs.qno_s,sQs.section,sm.note,sm.no_of_qns,sm.mandatory_qns,sm.each_qn_weightage,sm.marks as section_marks,sQs.chapter`)
            .leftJoin(QuestionPaperModal, 'qpm', 'qpm.id=qp.qpcode')
            .leftJoin(ClassEntity, 'class', 'class.id=qpm.class')
            .leftJoin(Subject, 'subject', 'subject.id=qpm.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=qpm.language')
            .leftJoin(SectionQuestionMappingEntity, 'sQs', `sQs.question_paper=qp.id`)
            .leftJoin(SectionWiseModel, 'sm', `sm.id=sQs.section`)
            .where(`qp.id='${req.qnpId}'`)
        const data = await classData.getRawMany();
        return data;
    }

    async getAllQuestionPapers(req: qPRequestModel) {
        const classData = this.createQueryBuilder('qp')
            .select(`qp.id,qp.timestamp,class.class as class,subject.subject,language.language as language,qpm.no_of_sections as noOfSections,qpm.marks,qpm.total_questions as totalQuestions,qpm.time_limit as timeLimit,qpm.tagline,qp.setno,qp.paper_bundler_id as paperBundlerId,qpm.instructions`)
            .leftJoin(QuestionPaperModal, 'qpm', 'qpm.id=qp.qpcode')
            .leftJoin(ClassEntity, 'class', 'class.id=qpm.class')
            .leftJoin(Subject, 'subject', 'subject.id=qpm.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=qpm.language')
            .where(`qpm.class='${req.classId}'`)
            .orderBy(`qp.timestamp`, 'DESC')
        const data = await classData.getRawMany();
        return data;
    }

    async getAllQuestionPapersToMerge(req: QPaperMergeGerReqModel, mainModelPaperIds: number[]) {
        const classData = this.createQueryBuilder('qp')
            .select(`qp.id,qp.timestamp,class.class as class,subject.subject,language.language as language,qpm.no_of_sections as noOfSections,qpm.marks,qpm.total_questions as totalQuestions,qpm.time_limit as timeLimit,qpm.tagline,qp.setno,qp.paper_bundler_id as paperBundlerId,qpm.instructions,qpm.main_model_paper_id as mainModelPaperId`)
            .leftJoin(QuestionPaperModal, 'qpm', 'qpm.id=qp.qpcode')
            .leftJoin(ClassEntity, 'class', 'class.id=qpm.class')
            .leftJoin(Subject, 'subject', 'subject.id=qpm.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=qpm.language')
            .where(`qpm.class='${req.classId}'`)
        if (mainModelPaperIds.length > 0) {
            classData.andWhere(`qpm.main_model_paper_id in (${mainModelPaperIds.join(',')})`)
        }
        classData.orderBy(`qp.timestamp`, 'DESC')
        const ata = await classData.getRawMany();
        return ata;
    }

    async getAllQuestionPapersOfGivenBundlePaperId(classId: number, qpId: number) {
        const classData =  this.createQueryBuilder('qp')
            .select(`qp.id,qp.timestamp,class.class as class,subject.subject,language.language as language,qpm.no_of_sections as noOfSections,qpm.marks,qpm.total_questions as totalQuestions,qpm.time_limit as timeLimit,qpm.tagline,qp.setno,qp.paper_bundler_id as paperBundlerId,qpm.instructions`)
            .leftJoin(QuestionPaperModal, 'qpm', 'qpm.id = qp.qpcode')
            .leftJoin(ClassEntity, 'class', 'class.id = qpm.class')
            .leftJoin(Subject, 'subject', 'subject.id = qpm.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id = qpm.language')
            .where(`qpm.class = :classId`, { classId })
            .andWhere(
                qb => {
                    const sub = qb.subQuery()
                        .select('inner_qp.paper_bundler_id')
                        .from(QuestionPapers, 'inner_qp')
                        .where('inner_qp.id = :qpId')
                        .getQuery();
                    return `qp.paper_bundler_id = ${sub}`;
                },
                { qpId }
            )
            .orderBy('qp.timestamp', 'DESC')

        const data = await classData.getRawMany();
        return data;
    }
}